import React, { useCallback, useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { NkConfirmDialog, _NkInput as NkInput } from '@nordkap/nordkap-ui';
import AddIcon from '@material-ui/icons/Add';
import CustomField from './customField';
import { useStyles } from '../styles';
import { combineClasses } from '../../../../utils/styling';

export const Fields = props => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [customFieldToRemove, setCustomFieldToRemove] = useState('');
  const [customField, setCustomField] = useState({
    name: '',
    customFieldId: '',
  });

  const removeField = useCallback(id => {
    setCustomFieldToRemove(id);
    setConfirmDialogOpen(true);
  }, []);

  const closeOnYes = useCallback(() => {
    props.removeField(customFieldToRemove);
    setConfirmDialogOpen(false);
  }, [customFieldToRemove, props]);

  const closeOnNo = useCallback(() => {
    setConfirmDialogOpen(false);
  }, []);

  const addCustomField = useCallback(() => {
    props.addField(customField);
    setCustomField({ name: '', customFieldId: '' });
  }, [customField, props]);

  return (
    <>
      <NkConfirmDialog
        onYes={closeOnYes}
        onNo={closeOnNo}
        isOpen={confirmDialogOpen}
        message={t(
          'fieldsAndTemplatesPage.areYouSureYouWantToDeleteCustomFieldMessage'
        )}
        subMessage={t(
          'fieldsAndTemplatesPage.areYouSureYouWantToDeleteCustomFieldSubmessage'
        )}
        confirmLabel={t('global.buttons.ok')}
        cancelLabel={t('global.buttons.cancel')}
      />
      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        xs={8}
        spacing={3}
      >
        <Grid item container xs={4}>
          <label
            className={combineClasses([
              classes.Bold,
              classes.Required,
              classes.UpperCase,
            ])}
          >
            {props.fieldsAndTemplates.customFields.length !== 0
              ? t('fieldsAndTemplatesPage.configuredCustomFields')
              : t('fieldsAndTemplatesPage.noCustomFieldsAreSetUp')}
          </label>
        </Grid>
        <Grid item container xs={8} />
        {props.fieldsAndTemplates.customFields.map((field, index) => (
          <CustomField
            key={index}
            customField={field}
            changeField={props.changeField}
            removeField={removeField}
          />
        ))}
      </Grid>
      <Grid item container xs={4} />

      <Grid
        item
        xs={8}
        className={combineClasses([classes.MarginTop, classes.MarginBottom])}
      >
        <hr />
      </Grid>
      <Grid item container xs={4} />

      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        xs={8}
        spacing={3}
        className={classes.MarginBottom}
      >
        <Grid item container xs={4}>
          <label
            className={combineClasses([
              classes.Bold,
              classes.Required,
              classes.UpperCase,
            ])}
          >
            {t('fieldsAndTemplatesPage.addCustomField')}
          </label>
        </Grid>
        <Grid item container xs={8} />
        <Grid item container xs={4}>
          <NkInput
            name="newCustomField"
            type="text"
            variant="outlined"
            value={customField.name}
            onChange={event =>
              setCustomField({ name: event.target.value, customFieldId: null })
            }
            placeholder={t('fieldsAndTemplatesPage.newCustomFieldName')}
          />
        </Grid>
        <Grid item container xs={4}>
          <Button
            id="addCustomField"
            variant="contained"
            color="primary"
            disabled={!customField.name || customField.name === ''}
            title={t('fieldsAndTemplatesPage.addCustomField')}
            onClick={addCustomField}
            className={classes.CustomFieldButton}
          >
            <AddIcon />
          </Button>
        </Grid>
        <Grid item xs={3} />
      </Grid>
      <Grid item xs={4} />
    </>
  );
};

Fields.propTypes = {
  fieldsAndTemplates: PropTypes.object,
  changeField: PropTypes.func,
  removeField: PropTypes.func,
  addField: PropTypes.func,
};
